import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

class PrivateRoute extends Component {
    render() {
        const { auth, path } = this.props;
        const exact = this.props.exact ? true : false;
        const RouteComponent = this.props.component;
        return (
            <Route path={path} exact={exact} component={(props) => {
                    return (
                        auth.isEmpty !== true
                            ? <RouteComponent {...props} />
                            : <Redirect to='/' />
                    );
                }
            } />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loggedIn: state.loggedIn,
        auth: state.firebase.auth
    };
};

export default connect(mapStateToProps)(PrivateRoute);
